"use client";

import type { ReactNode } from "react";
import { usePricingTableContext } from "./PricingTableContext";

interface DynamicBillingTableProps {
  /** Table pre-rendered with monthly billing period */
  monthlyTable: ReactNode;
  /** Table pre-rendered with yearly billing period */
  yearlyTable: ReactNode;
}

/**
 * Client wrapper that switches between monthly/yearly pre-rendered tables
 * based on the billing cycle from PricingTableContext.
 */
export const DynamicBillingTable = ({ monthlyTable, yearlyTable }: DynamicBillingTableProps) => {
  const { billingCycle } = usePricingTableContext();

  return billingCycle === "yearly" ? yearlyTable : monthlyTable;
};
